import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Tooltip,
  Button,
  Form,
  Typography,
  Spin,
  Row,
  Col,
  Input,
  Modal,
  Divider,
  InputNumber,
  Space,
  Table,
  DatePicker,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import {
  FolderOpenOutlined,
  DollarOutlined,
  FlagOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import styles from "../../../../../../../assets/styles/styles";
import { BOM } from "../../../../../../../services/definedMethod";
import cnt from "../../../../../../../services/definedConstant";
import { apiConfig, labelConfig } from "../../../../../group.config";

const Charges = (props) => {
  const { chargesList, state, userData, refreshDetail, refreshNote } = props;

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Payment due at",
      dataIndex: "paymentDueAt",
    },
    {
      title: "Calculation Type",
      dataIndex: "calculationType",
    },
    {
      title: "Repeats On",
      dataIndex: "repeatsOn",
    },
    {
      title: "Due",
      dataIndex: "due",
    },

    {
      title: "Paid",
      dataIndex: "paid",
    },
    {
      title: "Waived",
      dataIndex: "waived",
    },
    {
      title: "Outstanding",
      dataIndex: "outstanding",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Actions",
      render: (_, record) => {
        return (
          <>
            {record.chargeTimeType.toLowerCase() === "specified due date" &&
              record.amountOutstanding !== 0 && (
                <>
                  <DetailCharge
                    currentCustomerObj={state}
                    userData={userData}
                    chargeObj={record}
                    refreshDetail={refreshDetail}
                    refreshNote={refreshNote}
                  />
                  &nbsp;
                  {BOM.HasPermission("PAY_SAVINGSACCOUNTCHARGE") && (
                    <PayCharge
                      currentCustomerObj={state}
                      userData={userData}
                      chargeObj={record}
                      refreshDetail={refreshDetail}
                      refreshNote={refreshNote}
                    />
                  )}
                </>
              )}
          </>
        );
      },
    },
  ];

  return <Table columns={columns} dataSource={chargesList} />;
};

export default Charges;

const DetailCharge = (props) => {
  const {
    currentCustomerObj,
    userData,
    chargeObj,
    refreshDetail,
    refreshNote,
  } = props;

  const { session } = userData;
  const [useForm] = Form.useForm();
  const [inputField, setInputField] = useState([]);
  const [chargeDetail, setChargeDetail] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${apiConfig.SavingsAccounts}/${currentCustomerObj.childGSIMAccountId}/charges/${chargeObj.id}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setChargeDetail(objDetail);

        setInputField([
          {
            name: labelConfig.name,
            value: objDetail?.name
              ? BOM.SubstringFormat(objDetail?.name, 20)
              : "-",
            type: "general",
          },
          {
            name: labelConfig.chargeType,
            value: objDetail?.penalty ? "Penalty" : "Fees",
            type: "general",
          },

          {
            name: labelConfig.currency,
            value: objDetail?.currency ? objDetail?.currency?.name : "-",
            type: "general",
          },
          {
            name: labelConfig.paymentDueAt,
            value: objDetail.chargeTimeType
              ? objDetail.chargeTimeType?.value
              : "-",
            type: "general",
          },
          {
            name: labelConfig.paymentDueAsOf,
            value: objDetail?.dueDate
              ? BOM.FormatArrayDate(objDetail?.dueDate)
              : " - ",
            type: "general",
          },
          {
            name: labelConfig.repeatsOn,
            value: objDetail?.feeOnMonthDay
              ? BOM.FormatArrayDate(objDetail?.feeOnMonthDay)
              : " - ",
            type: "general",
          },

          {
            name: labelConfig.calculationType,
            value: objDetail?.chargeCalculationType
              ? objDetail?.chargeCalculationType?.value
              : "-",
            type: "general",
          },
          {
            name: labelConfig.due,
            value: `${
              objDetail?.currency?.code ? objDetail?.currency?.code : "-"
            } ${
              objDetail?.amountOrPercentage
                ? objDetail?.amountOrPercentage
                : "0.00"
            }`,
            type: "general",
          },
          {
            name: labelConfig.paid,
            value: `${
              objDetail?.currency?.code ? objDetail?.currency?.code : "-"
            } ${objDetail?.amountPaid ? objDetail?.amountPaid : "0.00"}`,
            type: "general",
          },
          {
            name: labelConfig.waived,
            value: `${
              objDetail?.currency?.code ? objDetail?.currency?.code : "-"
            } ${objDetail?.amountWaived ? objDetail?.amountWaived : "0.00"}`,
            type: "general",
          },
          {
            name: labelConfig.outstanding,
            value: `${
              objDetail?.currency?.code ? objDetail?.currency?.code : "-"
            } ${
              objDetail?.amountOutstanding
                ? objDetail?.amountOutstanding
                : "0.00"
            }`,
            type: "general",
          },
        ]);

        setIsLoading(false);
      }
    });
  };
  const showModal = () => {
    setIsModalOpen(true);
    getDetailById();
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  function handleWaiveCharge() {
    let action = "Waive  ";
    let label = chargeDetail.name;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        const params = {
          command: "waive",
        };
        const url = `${apiConfig.SavingsAccounts}/${currentCustomerObj.childGSIMAccountId}/charges/${chargeDetail.id}`;
        const body = {
          method: "POST",
          dateFormat: "dd MMMM yyyy",
          locale: "en",
          session,
          params,
        };

        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.waivedChargeMsg);
            setIsModalOpen(false);
            refreshDetail();
            refreshNote();

            //STOP LOAD
            setIsLoading(false);
          }
        });
      },
      function () {
        // No button
      }
    );
  }

  return (
    <>
      <Tooltip title={`View Detail`}>
        <Button
          type="primary"
          icon={<FolderOpenOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Charge Detail"
        centered
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={800}
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Form layout="vertical" form={useForm}>
            <div
              style={{
                textAlign: "right",
              }}
            >
              {BOM.HasPermission("WAIVE_SAVINGSACCOUNTCHARGE") && (
                <Space size="small">
                  <Button
                    type="primary"
                    shape="round"
                    icon={<FlagOutlined />}
                    className="of-primaryBtnColor"
                    onClick={() => handleWaiveCharge(chargeDetail)}
                    danger={true}
                  >
                    Waive Charge
                  </Button>
                </Space>
              )}
            </div>
            <Row>
              <Divider orientation="left">{labelConfig.generalInfo}</Divider>
              {inputField.map(
                (item, index) =>
                  item?.type?.toLowerCase() === "general" && (
                    <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={item.name}>
                        <Input
                          disabled
                          value={item.value}
                          className="of-bold-disable-input"
                        />
                      </Form.Item>
                    </Col>
                  )
              )}
            </Row>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

const PayCharge = (props) => {
  const {
    currentCustomerObj,
    userData,
    chargeObj,
    refreshDetail,
    refreshNote,
  } = props;

  const { session } = userData;
  const { Text } = Typography;
  const { TextArea } = Input;

  const [useForm] = Form.useForm();
  const [chargeDetail, setChargeDetail] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getTemplate = () => {
    const params = {
      command: "paycharge",
    };

    const url = `${apiConfig.SavingsAccounts}/${currentCustomerObj.childGSIMAccountId}/charges/${chargeObj.id}`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        setChargeDetail(objList);

        useForm.setFieldsValue({
          amount: objList.amountOutstanding,
        });

        setIsLoading(false);
      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
    getTemplate();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onPayCharge = (formValues) => {
    formValues.dueDate = formValues.dueDate
      ? BOM.DateTime(formValues.dueDate, "only-date")
      : formValues.dueDate;

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      `${apiConfig.SavingsAccounts}/${currentCustomerObj.childGSIMAccountId}/charges/${chargeObj.id}?command=paycharge`,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.payChargeMsg);
          // close modal
          setIsModalOpen(false);

          //refresh the list
          refreshDetail();
          refreshNote();

          //STOP LOAD
          setIsLoading(false);
        }
      }
    );
  };

  return (
    <>
      <Tooltip title={`Pay Charge`}>
        <Button
          type="primary"
          icon={<DollarOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Pay Charge"
        open={isModalOpen}
        okText="Pay"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onPayCharge}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row style={{ justifyContent: "space-betwen" }}>
            <Divider orientation="left">{labelConfig.chargeInfo}</Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="amount"
                label={<Text>{labelConfig.amount}</Text>}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.amount),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="dueDate"
                label={<Text>{labelConfig.paymentDate}</Text>}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.paymentDate),
                  },
                ]}
              >
                <DatePicker style={{ width: "100%", height: 35 }} />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item name="note" label={<Text>{labelConfig.note}</Text>}>
                <TextArea
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.note)}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};
